angular.module('app').component('cartThankComponent', {
	templateUrl: 'app/components/cart-thank/cart-thank.tmpl.html',
	controller: function ($state, $http, appConfig, localStorageService, modalService, $stateParams, authService) {
		const vm = this;

		vm.orderId = localStorageService.get('orderId');
		vm.receiptURL = localStorageService.get('rcptURL');
		vm.reports = localStorageService.get('reportPdf');
		vm.courseVideo = localStorageService.get('courseVideo');
		vm.courseImageUrl = localStorageService.get('courseImageUrl');
		vm.courseHeader = localStorageService.get('courseHeader');
		vm.courseFacultyName = localStorageService.get('courseFacultyName');
		vm.coursePublishedDate = localStorageService.get('coursePublishedDate');
		// Huedata Academy purchases (set by cart-checkout-methods for LearnProduct
		// lines): link to My learning and, for a hosted course, to the course.
		const COURSE_URL = { 'color-fundamentals': '/learn/color-fundamentals/' };
		const learn = localStorageService.get('learnPurchase') || [];
		vm.learn = Array.isArray(learn) && learn.length > 0;
		vm.learnCourses = (Array.isArray(learn) ? learn : [])
			.filter(function (p) { return p && p.kind === 'course' && /^course_/.test(p.code || ''); })
			.map(function (p) {
				const slug = String(p.code).replace(/^course_/, '').replace(/_/g, '-');
				return { title: p.header || 'your course', url: COURSE_URL[slug] || null };
			})
			.filter(function (c) { return !!c.url; });
		// The certificate name is asked here, right after payment, so a learner
		// who goes straight into the course still gets a named certificate.
		vm.profile = { needed: false, name: '', saving: false, saved: false, error: '' };
		const learnApi = appConfig.dashboardServiceUrl + 'api/learn/profile';
		const tokenParams = function () { return authService && authService.token ? { token: authService.token } : {}; };
		if (vm.learn) {
			$http.get(learnApi, { params: tokenParams(), withCredentials: true }).then(function (res) {
				const d = res.data || {};
				const p = d.profile || {};
				if (!p.completed) {
					vm.profile.needed = true;
					vm.profile.name = p.certificate_name || (d.defaults && d.defaults.certificate_name) || '';
				}
			}, function () {});
		}
		vm.saveProfile = function () {
			const name = String(vm.profile.name || '').trim();
			if (name.length < 2) { vm.profile.error = 'Enter your full name as it should appear on the certificate.'; return; }
			vm.profile.saving = true; vm.profile.error = '';
			$http.put(learnApi, { profile: { certificate_name: name } }, { params: tokenParams(), withCredentials: true })
				.then(function () { vm.profile.saved = true; vm.profile.needed = false; },
					function () { vm.profile.error = 'That did not save. You can add it later in My learning.'; })
				.finally(function () { vm.profile.saving = false; });
		};
		localStorageService.remove('learnPurchase');
		localStorageService.remove('orderId');
		localStorageService.remove('purchase');
		localStorageService.set('products', { courses: {}, reports: {}, teaching_materials: {} });

		vm.openVideo = function () {
			window.parent.postMessage({
				action: 'OpenVideoModal',
				data: {
					videoData: {
						header: vm.courseHeader,
						faculty_name: vm.courseFacultyName,
						image_url: vm.courseImageUrl,
						published_date: vm.coursePublishedDate,
						video_url: vm.courseVideo,
					},
				},
			});
		};
	},
});
